import { c as _c } from "react/compiler-runtime";
type LocationAddressDisplayProps = {
  className?: string;
  value: LocationAddressValue | null | undefined;
};
type LocationAddressValue = {
  address?: null | string;
  address_second_line?: null | string;
  city?: null | string;
  country?: null | string;
  country_code?: null | string;
  postcode?: null | string;
};
export const LocationAddressDisplay = t0 => {
  const $ = _c(13);
  const {
    className,
    value
  } = t0;
  if (!value) {
    return null;
  }
  const line1 = value.address ?? "";
  const line2 = value.address_second_line ?? "";
  const postcode = value.postcode ?? "";
  const city = value.city ?? "";
  const countryCode = value.country_code ?? value.country ?? "";
  let t1;
  if ($[0] !== city || $[1] !== countryCode || $[2] !== postcode) {
    t1 = [postcode, city, countryCode].filter(Boolean);
    $[0] = city;
    $[1] = countryCode;
    $[2] = postcode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const parts = t1;
  const line3 = parts.join(", ");
  let t2;
  if ($[4] !== line1 || $[5] !== line2 || $[6] !== line3) {
    t2 = [line1, line2, line3].filter(Boolean);
    $[4] = line1;
    $[5] = line2;
    $[6] = line3;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const lines = t2;
  if (lines.length === 0) {
    return null;
  }
  let t3;
  if ($[8] !== lines) {
    t3 = lines.map((line, i) => <span key={`${i}-${line}`}>{line}{i < lines.length - 1 && <br />}</span>);
    $[8] = lines;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== className || $[11] !== t3) {
    t4 = <span className={className} data-sentry-component="LocationAddressDisplay" data-sentry-source-file="location-address-display.tsx">{t3}</span>;
    $[10] = className;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};